<template>
  <Modal
    class="create-update-modal"
    :mask-closable="false"
    :closable="false"
    :title="actionText + '代理商'"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="110">
      <Row>
        <Col :sm="24" :xs="24">
          <FormItem label="代理商名称:" prop="agentName">
            <Input v-model.trim="handleForm.agentName" placeholder="请输入" maxlength="20" show-word-limit/>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="代理商地址:" prop="address">
            <Input v-model.trim="handleForm.address" placeholder="请输入" maxlength="100" show-word-limit/>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="是否激活:" prop="useState">
            <iSwitch v-model.trim="handleForm.useState" :true-value="1" :false-value="0" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </iSwitch>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import api from '../../api'

export default {
  name: 'AgentCreateUpdate',
  data () {
    return {
      modal: false,
      loading: false,
      action: 'create',
      dataIndex: null,
      handleForm: {
        agentId: '',
        agentName: '',
        address: '',
        useState: 0
      },
      handleValidate: {
        agentName: [
          { required: true, whitespace: true, message: '请输入代理商名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    actionText () {
      return this.action === 'create' ? '新增' : '编辑'
    }
  },
  methods: {
    show (action = 'create', data = {}, index) {
      this.action = action
      if (this.action === 'update') {
        this.handleForm = {
          agentId: data.id,
          agentName: data.agentName,
          address: data.address,
          useState: data.useState
        }
        this.dataIndex = index
      }
      this.modal = true
    },
    hide () {
      this.$refs['handleForm'].resetFields()
      this.handleForm.agentId = ''
      this.dataIndex = null
      this.loading = false
      this.modal = false
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      let queryParams = {
        ...this.handleForm
      }
      let submitApi = api.agent.agentCreateUpdate
      if (this.action === 'create') {
        delete queryParams.agentId
      }
      this.loading = true
      submitApi(queryParams).then(res => {
        this.$emit('success', this.action, {
          ...queryParams
        }, this.dataIndex)
        this.$Message.success(this.actionText + '成功！')
        this.hide()
      }).catch(err => {
        this.$Message.error(this.actionText + '失败：' + err.message)
      }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
